<template>
  <sidebar :title="`Top Up ${selectedSubRetailer?.name || ''} Balance`" :show="showSubRetailerBalanceSidebar"
    @on-close="close" size="sm">
    <template v-slot:body>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Amount</label>
            <div class="mb-3">
              <input type="number" class="form-control" :disabled="subRetailerSubmitting" v-model="amount"
                @focus="$event.target.select()" min="0" @keydown="preventNegative($event)" />
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button type="button" class="btn bg-info bg-violet text-white w-100 mt-4 mb-0" @click="submitSubRetailer">
          <div class="spinner-border spinner-border-sm" role="status" v-if="subRetailerSubmitting">
            <span class="sr-only">Loading...</span>
          </div>
          Submit
        </button>
      </div>
    </template>
  </sidebar>
  <GlobalModal :show="modal.show" :title="modal.title" :message="modal.message" :type="modal.type"
    @confirm="modal.onConfirm" @cancel="modal.onCancel" @close="modal.show = false" />
</template>

<script>
import sidebar from "../../../../../components/sidebar.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import GlobalModal from "@/components/GlobalModal.vue";

export default {
  components: {
    sidebar,
    GlobalModal
  },
  data() {
    return {
      amount: 0,
      modal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  computed: {
    ...mapState({
      showSubRetailerBalanceSidebar: (state) =>
        state.retailerController.showSubRetailerBalanceSidebar,
      subRetailerSubmitting: (state) =>
        state.retailerController.subRetailerSubmitting,
      selectedSubRetailer: (state) =>
        state.retailerController.selectedSubRetailer,
      selectedRetailer: (state) => state.retailerController.selectedRetailer,
      retailers: (state) => state.retailerController.retailers,
    }),
  },
  methods: {
    ...mapActions({
      getRetailers: "retailerController/GetRetailers",
      getSubRetailers: "retailerController/GetSubRetailers",
      updateSubRetailerBalance: "retailerController/UpdateSubRetailerBalance",
    }),
    ...mapMutations({
      setShowSubRetailerBalanceSidebar:
        "retailerController/SET_ShowSubRetailerBalanceSidebar",
      selectSubRetailer: "retailerController/SELECT_SubRetailer",
      setSelectedRetailer: "retailerController/SET_SelectedRetailer",
    }),
    close() {
      this.selectSubRetailer(null);
      this.setShowSubRetailerBalanceSidebar(false);
      this.amount = 0;
    },
    async submitSubRetailer() {
      var result = await this.updateSubRetailerBalance(this.amount).catch(
        (error) => {
          //alert(error.data.Message);
          this.showModal(
            'error',
            `${error.data.Message}`,
          );
        }
      );
      if (result) {
        this.showModal(
          'success',
          `Sub Retailer ${this.selectedSubRetailer.name} successfully loaded.`,
        );
        await this.getRetailers();
        await this.getSubRetailers();

        const updated = this.retailers.find(
          (r) => r.retailerID === this.selectedRetailer.retailerID
        );
        if (updated) {
          this.setSelectedRetailer({ ...updated });
        }
        this.close();
      }
    },
    preventNegative(event) {
      if (event.key === "-" || event.key === "e") {
        event.preventDefault();
      }
    },
    showModal(type, title, message) {
      return new Promise((resolve) => {
        this.modal = {
          show: true,
          type,
          title,
          message,
          onConfirm: () => {
            this.modal.show = false;
            resolve(true);
          },
          onCancel: () => {
            this.modal.show = false;
            resolve(false);
          },
        };
      });
    }
  },
};
</script>

<style></style>
